"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("modules/configManager/ConfigApi");
const request_1 = __importDefault(require("@hotmart/request"));
class StreamingService {
    async fetchStatus() {
        const [findStreamingStatus, findHotmartPlayerStatus] = (await Promise.allSettled([
            (0, request_1.default)('config.findStreamingStatus'),
            (0, request_1.default)('config.findHotmartPlayerStatus')
        ])).map((result) => (result.status === 'fulfilled' ? result.value : {}));
        return {
            ...findStreamingStatus,
            hotmartPlayerActive: (findHotmartPlayerStatus === null || findHotmartPlayerStatus === void 0 ? void 0 : findHotmartPlayerStatus.active) || false
        };
    }
}
exports.default = new StreamingService();
